import { memo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoteDropdown from '../noteDropdown';

const Surgical = ({ selectedHistories, setSelectedHistories }) => {
  let { surgical } = selectedHistories || {};

  const allNotes = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || [],
  );

  let defaultData = surgical || {
    lucs: '',
    lucsStatus: '',
    appendicectomy: '',
    appendicectomyStatus: '',
    cholecystectomy: '',
    cholecystectomyStatus: '',
    laparotomy: '',
    laparotomyStatus: '',
    laparoscopy: '',
    laparoscopyStatus: '',
    tah: '',
    tahStatus: '',
    ulso: '',
    ulsoStatus: '',
    dlso: '',
    dlsoStatus: '',
    others: '',
    othersStatus: '',
  };

  let selectedData = surgical || defaultData;

  const handleData = (fieldName, val) => {
    const updatedSurgical = { ...selectedData, [fieldName]: val };
    setSelectedHistories({ ...selectedHistories, surgical: updatedSurgical });
  };

  const surgicalNotes = (itemElement) =>
    allNotes.filter(
      (n) =>
        n.elementType === 'surgicalHistory' &&
        n.itemElement?.toLowerCase() === itemElement.toLowerCase(),
    );

  return (
    <div className="surgical-history">
      <Row>
        <Col md={2} className="pt-1">
          LUCS:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`luck-status-yes`}
              label={`Yes`}
              checked={selectedData?.lucsStatus === 'yes'}
              onChange={(e) =>
                handleData('lucsStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`luck-status-no`}
              label={`No`}
              checked={selectedData?.lucsStatus === 'no'}
              onChange={(e) => handleData('lucsStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`luck-status-others`}
              label={`Others`}
              checked={selectedData?.lucsStatus === 'others'}
              onChange={(e) =>
                handleData('lucsStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.lucs || ''}
            onChange={(val) => handleData('lucs', val)}
            suggestions={surgicalNotes('lucs')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Appendicectomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`appendicectomy-yes`}
              label={`Yes`}
              checked={selectedData?.appendicectomyStatus === 'yes'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`appendicectomy-no`}
              label={`No`}
              checked={selectedData?.appendicectomyStatus === 'no'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`appendicectomy-others`}
              label={`Others`}
              checked={selectedData?.appendicectomyStatus === 'others'}
              onChange={(e) =>
                handleData('appendicectomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.appendicectomy || ''}
            onChange={(val) => handleData('appendicectomy', val)}
            suggestions={surgicalNotes('appendicectomy')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Cholecystectomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-yes`}
              label={`Yes`}
              checked={selectedData?.cholecystectomyStatus === 'yes'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-no`}
              label={`No`}
              checked={selectedData?.cholecystectomyStatus === 'no'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`cholecystectomyStatus-others`}
              label={`Others`}
              checked={selectedData?.cholecystectomyStatus === 'others'}
              onChange={(e) =>
                handleData('cholecystectomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.cholecystectomy || ''}
            onChange={(val) => handleData('cholecystectomy', val)}
            suggestions={surgicalNotes('cholecystectomy')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Laparotomy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`laparotomy-yes`}
              label={`Yes`}
              checked={selectedData?.laparotomyStatus === 'yes'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparotomy-no`}
              label={`No`}
              checked={selectedData?.laparotomyStatus === 'no'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparotomy-others`}
              label={`Others`}
              checked={selectedData?.laparotomyStatus === 'others'}
              onChange={(e) =>
                handleData('laparotomyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.laparotomy || ''}
            onChange={(val) => handleData('laparotomy', val)}
            suggestions={surgicalNotes('laparotomy')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Laparoscopy:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`laparoscopy-yes`}
              label={`Yes`}
              checked={selectedData?.laparoscopyStatus === 'yes'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparoscopy-no`}
              label={`No`}
              checked={selectedData?.laparoscopyStatus === 'no'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'no', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`laparoscopy-others`}
              label={`Others`}
              checked={selectedData?.laparoscopyStatus === 'others'}
              onChange={(e) =>
                handleData('laparoscopyStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.laparoscopy || ''}
            onChange={(val) => handleData('laparoscopy', val)}
            suggestions={surgicalNotes('laparoscopy')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          Total Abdominal History (TAH):
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`tah-yes`}
              label={`Yes`}
              checked={selectedData?.tahStatus === 'yes'}
              onChange={(e) => handleData('tahStatus', 'yes', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`tah-no`}
              label={`No`}
              checked={selectedData?.tahStatus === 'no'}
              onChange={(e) => handleData('tahStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`tah-others`}
              label={`Others`}
              checked={selectedData?.tahStatus === 'others'}
              onChange={(e) =>
                handleData('tahStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.tah || ''}
            onChange={(val) => handleData('tah', val)}
            suggestions={surgicalNotes('tah')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          TAH With BLSO:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`ulso-yes`}
              label={`Yes`}
              checked={selectedData?.ulsoStatus === 'yes'}
              onChange={(e) =>
                handleData('ulsoStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`ulso-no`}
              label={`No`}
              checked={selectedData?.ulsoStatus === 'no'}
              onChange={(e) => handleData('ulsoStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`ulso-others`}
              label={`Others`}
              checked={selectedData?.ulsoStatus === 'others'}
              onChange={(e) =>
                handleData('ulsoStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.ulso || ''}
            onChange={(val) => handleData('ulso', val)}
            suggestions={surgicalNotes('ulso')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
          TLH With BLSO:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`dlso-yes`}
              label={`Yes`}
              checked={selectedData?.dlsoStatus === 'yes'}
              onChange={(e) =>
                handleData('dlsoStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`dlso-no`}
              label={`No`}
              checked={selectedData?.dlsoStatus === 'no'}
              onChange={(e) => handleData('dlsoStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`dlso-others`}
              label={`Others`}
              checked={selectedData?.dlsoStatus === 'others'}
              onChange={(e) =>
                handleData('dlsoStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.dlso || ''}
            onChange={(val) => handleData('dlso', val)}
            suggestions={surgicalNotes('dlso')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={2} className="pt-1">
        Others:
        </Col>
        <Col md={4}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Check
              type={`radio`}
              id={`others-yes`}
              label={`Yes`}
              checked={selectedData?.othersStatus === 'yes'}
              onChange={(e) =>
                handleData('othersStatus', 'yes', e.target.checked)
              }
            />
            <Form.Check
              type={`radio`}
              id={`others-no`}
              label={`No`}
              checked={selectedData?.othersStatus === 'no'}
              onChange={(e) => handleData('othersStatus', 'no', e.target.checked)}
            />
            <Form.Check
              type={`radio`}
              id={`others-others`}
              label={`Others`}
              checked={selectedData?.othersStatus === 'others'}
              onChange={(e) =>
                handleData('othersStatus', 'others', e.target.checked)
              }
            />
          </div>
        </Col>
        <Col>
          <NoteDropdown
            value={selectedData?.others || ''}
            onChange={(val) => handleData('others', val)}
            suggestions={surgicalNotes('others')}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(Surgical);
